export const formatPrice = (details, t) => {
  const price = parseFloat(details.price)
  if (!details.recurring) {
    return `$${price.toFixed(2)}`
  } else {
    if (details.recurDetails.type === 'month') {
      if (details.recurDetails.length === 1) {
        return t('tv_app.price_recurring_monthly', {
          _: '$%{price} /mo',
          price: price.toFixed(2),
        })
      } else {
        return t('tv_app.price_recurring_month_interval', {
          _: '$%{price} /%{length} mo',
          price: price.toFixed(2),
          length: details.recurDetails.length,
        })
      }
    } else if (details.recurDetails.type === 'day') {
      if (details.recurDetails.length === 1) {
        return t('tv_app.price_recurring_daily', {
          _: '$%{price} /day',
          price: price.toFixed(2),
        })
      } else {
        return t('tv_app.price_recurring_day_interval', {
          _: '$%{price} /%{length} days',
          price: price.toFixed(2),
          length: details.recurDetails.length,
        })
      }
    } else {
      if (details.recurDetails.length === 1) {
        return `$${price.toFixed(2)} /${details.recurDetails.type}`
      } else {
        return `$${price.toFixed(2)} /${details.recurDetails.length} ${
          details.recurDetails.type
        }`
      }
    }
  }
}
